module.exports = __webpack_public_path__ + "img/header.c960fb5e.png";